import * as TWEEN from '@tweenjs/tween.js'
import { fishEye } from './fishEye'

export function createTween(bezierCenter, rotateSpeed, holder, verticesOriginArray, planeMask, plane) {
    if (rotateSpeed > 0) {
        var textureOffset = { x: bezierCenter.size / 2 }
        return new TWEEN.Tween(textureOffset)
            .to(
                { x: bezierCenter.size * 2 - bezierCenter.size / 2 },
                166000 / rotateSpeed,
            )
            .easing(TWEEN.Easing.Linear.None)
            .onUpdate(
                () => {
                    bezierCenter.x = textureOffset.x
                    holder.x = -textureOffset.x
                    fishEye(bezierCenter, verticesOriginArray, planeMask, plane)
                }
            )
    }
    return null
}


function animate(time) {
    requestAnimationFrame(animate)
    TWEEN.update(time)
}
requestAnimationFrame(animate)